import React, { useMemo, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { DownloadIcon, Theme } from '@spoiler-alert/ui-library';

const useStyles = createUseStyles({
  downloadButtonWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    maxWidth: 400,
    alignItems: 'start',
    textAlign: 'left',
  },
  filename: {
    fontSize: 12,
    color: Theme.grey50,
    '&>a': {
      color: Theme.text,
      textDecoration: 'none',
    },
  },
  downloadLink: {
    fontSize: '1.2em',
    '&>svg': {
      height: '1em',
      fill: Theme.teal,
    },
  },
});

interface DownloadButtonProps {
  downloadPath: string;
  kind?: string;
  path?: string;
  fileName?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ kind, downloadPath, path, fileName }) => {
  const classes = useStyles();
  const downloadRef = useRef<HTMLAnchorElement>(null);
  const shortFileName = useMemo(() => {
    if (fileName) return fileName;
    let _path = downloadPath;
    if (path) _path = path;
    const parts = _path.split('/');
    const file = parts.pop();
    if (!file) return '';
    const fileAndArgs = file.split('?');
    return fileAndArgs.shift();
  }, [downloadPath, path, fileName]);

  const clickHandler = () => {
    if (!downloadRef.current) return;
    downloadRef.current.click();
  };

  return (
    <div className={classes.downloadButtonWrap}>
      <a className={classes.downloadLink} onClick={clickHandler}>
        <DownloadIcon /> {kind}
      </a>
      <div className={classes.filename}>
        <a ref={downloadRef} target="_blank" href={downloadPath} download={shortFileName} rel="noreferrer">
          {shortFileName}
        </a>
      </div>
    </div>
  );
};

export default DownloadButton;
